import {useRef, useEffect} from 'external/react'
import {
  clsx
 ,Box
 ,Fade
 ,Table 
 ,TableContainer 
 ,TableBody 
 ,TableRow 
 ,TableCell 
} from 'external/material'

import GradesHead from './GradesHead'

import useStudentContext from 'hooks/student'
import useTranslations from 'hooks/translations'

export default function Grades() {
  const {grades} = useStudentContext()
  const {formatDate, translate} = useTranslations()

  return (
    <Box className="grades">
      <TableContainer className="gradesTableContainer">
        <Table className="gradesTable">
          <GradesHead />
          <Fade in={grades.length > 0}>
          <TableBody>
            {grades.map((grade, i) => {
              return (<TableRow key={i}>
                <TableCell className="nameCell" align="left">
                  <span className="date">{formatDate(grade.date)}</span>
                </TableCell>
                <TableCell align="left">
                  <span className="gradeName">{translate(grade.type)}</span>
                </TableCell>
                <TableCell align="left">
                  <span className="gradeName">{grade.name}</span>
                </TableCell>
                <TableCell align="left">
                  <span className="gradeName">{grade.term}</span>
                </TableCell>
                <TableCell align="left">
                  <span className={"points"}>{grade.points} / {grade.total}</span>
                </TableCell>
                <TableCell align="center">
                  <span className="actions"></span>
                </TableCell>          
              </TableRow>)
            })}
          </TableBody>
          </Fade>
        </Table>
      </TableContainer>
    </Box>
  )
}
